/** @format */

import React, { FunctionComponent } from 'react';
import GridContainer from '../../../components/Grid/GridContainer';
import PlatformIpPoolNumber from '../../../interfaces/platform/PlatformIpPoolNumber';
import { history } from '../../../core/history';
import { Auth, tokenInfo } from '../../../modules/auth/Auth';
import GridItem from '../../../components/Grid/GridItem';
import Typography from '@material-ui/core/Typography';
import I18n from '../../../components/Translate/I18n';
import { DateHelper } from '../../../helpers/DateHelper';
import i18next from 'i18next';
import { IpStateSimpleHelper } from '../../lib/search/IpStateSimpleHelper';
import BackTextButton from '../../../components/Buttons/BackTextButton';

type IpViewType = {
    item: PlatformIpPoolNumber;
    ipStateHelper: IpStateSimpleHelper;
};

export const IpView: FunctionComponent<IpViewType> = ({ item, ipStateHelper }): React.ReactElement => {
    const isSuperUser = Auth.getUserType() === tokenInfo.SYSTEM_TYPE_MVNO_ADMIN;
    const callBack = (): void => history.goBack();

    const getIpState = (ipState: number): string | null => {
        let ipStateName = ipStateHelper.getNameByMap(ipState);
        if (ipStateName) {
            ipStateName = i18next.t(ipStateName).toString();
        }
        return ipStateName;
    };

    return (
        <GridContainer>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    <I18n trans="pools:pool.ip" />
                </Typography>
            </GridItem>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    {item.ip} {item.private ? <I18n trans="pools:apn.private" /> : <I18n trans="pools:apn.public" />}
                </Typography>
            </GridItem>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    <I18n trans="simcard:list.msisdn" />
                </Typography>
            </GridItem>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    {item.msisdn}
                </Typography>
            </GridItem>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    <I18n trans="pools:pool.imsi" />
                </Typography>
            </GridItem>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    {item.imsi}
                </Typography>
            </GridItem>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    <I18n trans="pools:pool.ip_state" />
                </Typography>
            </GridItem>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    {getIpState(item.ipState)}
                </Typography>
            </GridItem>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    <I18n trans="pools:pool.ip_apn" />
                </Typography>
            </GridItem>
            <GridItem xs={6}>
                <Typography variant="subtitle2" gutterBottom>
                    {item.definedApnName}
                </Typography>
            </GridItem>
            {isSuperUser && (
                <React.Fragment>
                    <React.Fragment>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                <I18n trans="pools:pool.share_date" />
                            </Typography>
                        </GridItem>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                {DateHelper.format(item.sharedDate)}
                            </Typography>
                        </GridItem>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                <I18n trans="pools:view.partner" />
                            </Typography>
                        </GridItem>
                        <GridItem xs={6}>
                            <Typography variant="subtitle2" gutterBottom>
                                {item.ownerPlatformResellerName}
                            </Typography>
                        </GridItem>
                    </React.Fragment>
                </React.Fragment>
            )}
            <GridItem xs={12}>
                <BackTextButton callback={callBack} callbackParam={{}} size="sm" />
            </GridItem>
        </GridContainer>
    );
};
